/* DermaLux — comportamiento compartido de las secciones belleza-cine-*.
   Se carga desde varias secciones a la vez, por eso todo esta protegido
   contra doble ejecucion. */
(function () {
  if (window.__bcCine) return;
  window.__bcCine = true;

  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Revelado al entrar en pantalla ---- */
  function revelar(raiz) {
    var items = (raiz || document).querySelectorAll('.bc-rev:not(.is-visible)');
    if (!items.length) return;

    if (reducido || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var retraso = parseInt(el.dataset.bcRetraso || '0', 10);
        setTimeout(function () { el.classList.add('is-visible'); }, retraso);
        obs.unobserve(el);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.06 });

    items.forEach(function (el) { obs.observe(el); });
  }

  /* ---- Video de fondo: solo reproduce lo que esta a la vista ---- */
  function videos(raiz) {
    var vids = (raiz || document).querySelectorAll('video[data-bc-video]');
    if (!vids.length) return;

    vids.forEach(function (v) {
      v.muted = true;
      v.setAttribute('muted', '');
      v.playsInline = true;
    });

    if (!('IntersectionObserver' in window)) {
      vids.forEach(function (v) { v.play().catch(function () {}); });
      return;
    }

    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { threshold: 0.15 });

    vids.forEach(function (v) { obs.observe(v); });
  }

  /* ---- Acordeon del FAQ ---- */
  function faq(raiz) {
    var btns = (raiz || document).querySelectorAll('[data-bc-faq-btn]:not([data-bc-listo])');
    btns.forEach(function (btn) {
      btn.setAttribute('data-bc-listo', '1');
      btn.addEventListener('click', function () {
        var item = btn.closest('.bc-faq__item');
        if (!item) return;
        var abierto = item.classList.toggle('is-abierto');
        btn.setAttribute('aria-expanded', abierto ? 'true' : 'false');
      });
    });
  }

  /* ---- Carrusel que avanza solo ----
     Se mueve con scrollTo sobre una pista con scroll-snap, no con transform:
     asi el usuario puede arrastrar con el dedo y el carrusel sigue el mismo
     estado, sin dos sistemas de posicion peleando.

     Se detiene cuando: el visitante lo toca o arrastra, el puntero esta
     encima, la seccion sale de pantalla, o la pestana pasa a segundo plano. */
  function carruseles(raiz) {
    var wraps = (raiz || document).querySelectorAll('[data-bc-carrusel]:not([data-bc-listo])');

    wraps.forEach(function (wrap) {
      wrap.setAttribute('data-bc-listo', '1');

      var pista = wrap.querySelector('[data-bc-pista-car]');
      var puntosWrap = wrap.querySelector('[data-bc-puntos-car]');
      if (!pista || pista.children.length < 2) return;

      var total = pista.children.length;
      var intervalo = parseInt(wrap.dataset.bcIntervalo || '3500', 10);
      var timer = null;
      var pausadoPorUsuario = false;
      var visible = true;

      function paso() {
        var a = pista.children[0].getBoundingClientRect();
        var b = pista.children[1] ? pista.children[1].getBoundingClientRect() : null;
        return b ? Math.max(1, b.left - a.left) : a.width;
      }

      function indice() {
        return Math.round(pista.scrollLeft / paso());
      }

      function irA(i, suave) {
        pista.scrollTo({ left: i * paso(), behavior: suave === false ? 'auto' : 'smooth' });
      }

      /* Puntos */
      var puntos = [];
      if (puntosWrap) {
        for (var i = 0; i < total; i++) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', 'Ir a la reseña ' + (i + 1) + ' de ' + total);
          if (i === 0) b.className = 'on';
          (function (idx) {
            b.addEventListener('click', function () { pausar(true); irA(idx); });
          })(i);
          puntosWrap.appendChild(b);
          puntos.push(b);
        }
      }

      function pintarPuntos() {
        if (!puntos.length) return;
        var act = indice();
        puntos.forEach(function (p, k) { p.classList.toggle('on', k === act); });
      }

      pista.addEventListener('scroll', pintarPuntos, { passive: true });

      /* Avance automatico */
      function avanzar() {
        if (pausadoPorUsuario || !visible || document.hidden) return;
        var siguiente = indice() + 1;
        /* Al llegar al final vuelve al principio sin animacion, para que no
           se vea el barrido largo de derecha a izquierda. */
        if (siguiente >= total) irA(0, false);
        else irA(siguiente);
      }

      function arrancar() {
        if (reducido || timer) return;
        timer = setInterval(avanzar, intervalo);
      }
      function detener() {
        if (!timer) return;
        clearInterval(timer);
        timer = null;
      }
      function pausar(definitivo) {
        pausadoPorUsuario = true;
        detener();
        if (!definitivo) return;
        /* Tras tocarlo, se le devuelve el control al visitante un rato largo. */
        clearTimeout(wrap.__bcReanudar);
        wrap.__bcReanudar = setTimeout(function () {
          pausadoPorUsuario = false;
          arrancar();
        }, Math.max(intervalo * 3, 9000));
      }

      ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) {
        pista.addEventListener(ev, function () { pausar(true); }, { passive: true });
      });
      wrap.addEventListener('mouseenter', function () { pausadoPorUsuario = true; detener(); });
      wrap.addEventListener('mouseleave', function () { pausadoPorUsuario = false; arrancar(); });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) detener(); else arrancar();
      });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entradas) {
          entradas.forEach(function (e) {
            visible = e.isIntersecting;
            if (visible) arrancar(); else detener();
          });
        }, { threshold: 0.2 }).observe(wrap);
      } else {
        arrancar();
      }
    });
  }

  function iniciar(raiz) {
    revelar(raiz);
    videos(raiz);
    faq(raiz);
    carruseles(raiz);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { iniciar(document); });
  } else {
    iniciar(document);
  }

  /* El editor de Shopify vuelve a montar secciones sin recargar la pagina. */
  document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
})();